DR.web = DR.web || {};
DR.web.struct = DR.web.struct || {};
DR.web.select = DR.web.select || {};
/** @extends {DR._Base} */
DR.web.struct.CrazyWolfSubmission = function(par){
	/** @private */
	this._t = 1368;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.hasConsent)) this.hasConsent = Boolean(par.hasConsent);
	if(DR._Base.is(par.id)) this.id = (parseInt(par.id)||0);
	if(DR._Base.is(par.image)) this.image = DR._Base.cast(par.image);
	if(DR._Base.is(par.taskId)) this.taskId = (parseInt(par.taskId)||0);
	if(DR._Base.is(par.teamId)) this.teamId = (parseInt(par.teamId)||0);
	if(DR._Base.is(par.type)) this.type = Number(par.type);
	if(DR._Base.is(par.video)) this.video = DR._Base.cast(par.video);
};
DR._Base._types[1368] = DR.web.struct.CrazyWolfSubmission;
DR.web.struct.CrazyWolfSubmission.TYPE_IMAGE = 1;
DR.web.struct.CrazyWolfSubmission.TYPE_VIDEO = 2;
DR.web.struct.CrazyWolfSubmission[__P] = new DR._Base;
DR.web.struct.CrazyWolfSubmission[__P][__C] = DR.web.struct.CrazyWolfSubmission;
/** @type {Boolean} */
DR.web.struct.CrazyWolfSubmission.prototype.hasConsent = null;
/** @type {Number} */
DR.web.struct.CrazyWolfSubmission.prototype.id = null;
/** @type {DR.roadgames.struct.Image|null} */
DR.web.struct.CrazyWolfSubmission.prototype.image = null;
/** @type {Number} */
DR.web.struct.CrazyWolfSubmission.prototype.taskId = null;
/** @type {Number} */
DR.web.struct.CrazyWolfSubmission.prototype.teamId = null;
/** @type {Number} */
DR.web.struct.CrazyWolfSubmission.prototype.type = null;
/** @type {DR.roadgames.struct.Video|null} */
DR.web.struct.CrazyWolfSubmission.prototype.video = null;
 
/** @extends {DR._Base} */
DR.web.struct.InstagramItem = function(par){
	/** @private */
	this._t = 1324;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.image)) this.image = DR._Base.cast(par.image);
	if(DR._Base.is(par.url)) this.url = String(par.url||'');
};
DR._Base._types[1324] = DR.web.struct.InstagramItem;
DR.web.struct.InstagramItem[__P] = new DR._Base;
DR.web.struct.InstagramItem[__P][__C] = DR.web.struct.InstagramItem;
/** @type {DR.roadgames.struct.Image} */
DR.web.struct.InstagramItem.prototype.image = null;
/** @type {String} */
DR.web.struct.InstagramItem.prototype.url = null;
 
/** @extends {DR._Base} */
DR.web.struct.Quote = function(par){
	/** @private */
	this._t = 1374;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.id)) this.id = (parseInt(par.id)||0);
	if(DR._Base.is(par.image)) this.image = DR._Base.cast(par.image);
	if(DR._Base.is(par.languages)){
		var tmp = [];
		for( var k in par.languages ) tmp.push(String(par.languages [k]||''));
		this.languages = tmp;
	}
	if(DR._Base.is(par.type)) this.type = String(par.type||'');
};
DR._Base._types[1374] = DR.web.struct.Quote;
DR.web.struct.Quote[__P] = new DR._Base;
DR.web.struct.Quote[__P][__C] = DR.web.struct.Quote;
/** @type {Number} */
DR.web.struct.Quote.prototype.id = null;
/** @type {DR.roadgames.struct.Image} */
DR.web.struct.Quote.prototype.image = null;
/** @type {Array.<String>} */
DR.web.struct.Quote.prototype.languages = null;
/** @type {String} */
DR.web.struct.Quote.prototype.type = null;
 
/** @extends {DR._Base} */
DR.web.struct.GetCrazyWolfSubmissionsRe = function(par){
	/** @private */
	this._t = 1369;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.event)) this.event = DR._Base.cast(par.event);
	if(DR._Base.is(par.items)){
		var tmp = [];
		for( var k in par.items ) tmp.push(DR._Base.cast(par.items [k]));
		this.items = tmp;
	}
	if(DR._Base.is(par.requireConsent)) this.requireConsent = Boolean(par.requireConsent);
	if(DR._Base.is(par.tasks)){
		var tmp = {};
		for( var k in par.tasks ) tmp[k] = DR._Base.cast(par.tasks [k]);
		this.tasks = tmp;
	}
	if(DR._Base.is(par.teams)){
		var tmp = {};
		for( var k in par.teams ) tmp[k] = DR._Base.cast(par.teams [k]);
		this.teams = tmp;
	}
};
DR._Base._types[1369] = DR.web.struct.GetCrazyWolfSubmissionsRe;
DR.web.struct.GetCrazyWolfSubmissionsRe[__P] = new DR._Base;
DR.web.struct.GetCrazyWolfSubmissionsRe[__P][__C] = DR.web.struct.GetCrazyWolfSubmissionsRe;
/** @type {DR.events.struct.Event} */
DR.web.struct.GetCrazyWolfSubmissionsRe.prototype.event = null;
/** @type {Array.<DR.web.struct.CrazyWolfSubmission>} */
DR.web.struct.GetCrazyWolfSubmissionsRe.prototype.items = null;
/** @type {Boolean} */
DR.web.struct.GetCrazyWolfSubmissionsRe.prototype.requireConsent = null;
/** @type {Object.<Number,DR.crazywolf.struct.Task>} */
DR.web.struct.GetCrazyWolfSubmissionsRe.prototype.tasks = null;
/** @type {Object.<Number,DR.teams.struct.Team>} */
DR.web.struct.GetCrazyWolfSubmissionsRe.prototype.teams = null;
 
/** @extends {DR._Base} */
DR.web.struct.EventList = function(par){
	/** @private */
	this._t = 1354;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.events)){
		var tmp = [];
		for( var k in par.events ) tmp.push(DR._Base.cast(par.events [k]));
		this.events = tmp;
	}
	if(DR._Base.is(par.featuredEvent)) this.featuredEvent = DR._Base.cast(par.featuredEvent);
	if(DR._Base.is(par.pgs)) this.pgs = (parseInt(par.pgs)||0);
};
DR._Base._types[1354] = DR.web.struct.EventList;
DR.web.struct.EventList[__P] = new DR._Base;
DR.web.struct.EventList[__P][__C] = DR.web.struct.EventList;
/** @type {Array.<DR.events.struct.Event>} */
DR.web.struct.EventList.prototype.events = null;
/** @type {DR.events.struct.Event|null} */
DR.web.struct.EventList.prototype.featuredEvent = null;
/** @type {Number} */
DR.web.struct.EventList.prototype.pgs = null;
 
/** @extends {DR._Base} */
DR.web.struct.GetInstagramFeedRe = function(par){
	/** @private */
	this._t = 1322;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.items)){
		var tmp = [];
		for( var k in par.items ) tmp.push(DR._Base.cast(par.items [k]));
		this.items = tmp;
	}
	if(DR._Base.is(par.username)) this.username = String(par.username||'');
};
DR._Base._types[1322] = DR.web.struct.GetInstagramFeedRe;
DR.web.struct.GetInstagramFeedRe[__P] = new DR._Base;
DR.web.struct.GetInstagramFeedRe[__P][__C] = DR.web.struct.GetInstagramFeedRe;
/** @type {Array.<DR.web.struct.InstagramItem>} */
DR.web.struct.GetInstagramFeedRe.prototype.items = null;
/** @type {String} */
DR.web.struct.GetInstagramFeedRe.prototype.username = null;
 
/** @extends {DR._Base} */
DR.web.struct.GetQuotesRe = function(par){
	/** @private */
	this._t = 1375;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.pgs)) this.pgs = (parseInt(par.pgs)||0);
	if(DR._Base.is(par.quotes)){
		var tmp = [];
		for( var k in par.quotes ) tmp.push(DR._Base.cast(par.quotes [k]));
		this.quotes = tmp;
	}
};
DR._Base._types[1375] = DR.web.struct.GetQuotesRe;
DR.web.struct.GetQuotesRe[__P] = new DR._Base;
DR.web.struct.GetQuotesRe[__P][__C] = DR.web.struct.GetQuotesRe;
/** @type {Number} */
DR.web.struct.GetQuotesRe.prototype.pgs = null;
/** @type {Array.<DR.web.struct.Quote>} */
DR.web.struct.GetQuotesRe.prototype.quotes = null;
 
/** @extends {DR._Base} */
DR.web.struct.GetTrustedByRe = function(par){
	/** @private */
	this._t = 1377;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.image)) this.image = DR._Base.cast(par.image);
};
DR._Base._types[1377] = DR.web.struct.GetTrustedByRe;
DR.web.struct.GetTrustedByRe[__P] = new DR._Base;
DR.web.struct.GetTrustedByRe[__P][__C] = DR.web.struct.GetTrustedByRe;
/** @type {DR.roadgames.struct.Image|null} */
DR.web.struct.GetTrustedByRe.prototype.image = null;
 
/** @extends {DR._Base} */
DR.web.struct.StatsRe = function(par){
	/** @private */
	this._t = 1325;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.adventurers)) this.adventurers = (parseInt(par.adventurers)||0);
	if(DR._Base.is(par.games)) this.games = (parseInt(par.games)||0);
};
DR._Base._types[1325] = DR.web.struct.StatsRe;
DR.web.struct.StatsRe[__P] = new DR._Base;
DR.web.struct.StatsRe[__P][__C] = DR.web.struct.StatsRe;
/** @type {Number} */
DR.web.struct.StatsRe.prototype.adventurers = null;
/** @type {Number} */
DR.web.struct.StatsRe.prototype.games = null;
 
/** @extends {DR._Method} */
DR.web.AddStats = function(par){
	this.select = [];
	/** @private */
	this._t = 1337;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1337] = DR.web.AddStats;
DR.web.AddStats[__CL] = "Web__AddStats";
DR.web.AddStats[__P] = new DR._Method;
DR.web.AddStats[__P][__C] = DR.web.AddStats;
/** @type {String} */
DR.web.AddStats.prototype.kw = null;
 
/** @extends {DR._Method} */
DR.web.GetCrazyWolfSubmissions = function(par){
	this.select = [];
	/** @private */
	this._t = 1370;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1370] = DR.web.GetCrazyWolfSubmissions;
DR.web.GetCrazyWolfSubmissions[__CL] = "Web__GetCrazyWolfSubmissions";
DR.web.GetCrazyWolfSubmissions[__P] = new DR._Method;
DR.web.GetCrazyWolfSubmissions[__P][__C] = DR.web.GetCrazyWolfSubmissions;
/** @type {String} */
DR.web.GetCrazyWolfSubmissions.prototype.code = null;
/** @type {DR.web.struct.GetCrazyWolfSubmissionsRe} */
DR.web.GetCrazyWolfSubmissions.prototype.re = null;
 
/** @extends {DR._Method} */
DR.web.GetEvents = function(par){
	this.select = [];
	/** @private */
	this._t = 1355;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1355] = DR.web.GetEvents;
DR.web.GetEvents[__CL] = "Web__GetEvents";
DR.web.GetEvents.TYPE_HOME = "home";
DR.web.GetEvents[__P] = new DR._Method;
DR.web.GetEvents[__P][__C] = DR.web.GetEvents;
/** @type {Number} */
DR.web.GetEvents.prototype.count = null;
/** @type {Number} */
DR.web.GetEvents.prototype.pg = null;
/** @type {String} */
DR.web.GetEvents.prototype.type = null;
/** @type {DR.web.struct.EventList} */
DR.web.GetEvents.prototype.re = null;
 
/** @extends {DR._Method} */
DR.web.GetInstagramFeed = function(par){
	this.select = [];
	/** @private */
	this._t = 1323;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1323] = DR.web.GetInstagramFeed;
DR.web.GetInstagramFeed[__CL] = "Web__GetInstagramFeed";
DR.web.GetInstagramFeed[__P] = new DR._Method;
DR.web.GetInstagramFeed[__P][__C] = DR.web.GetInstagramFeed;
/** @type {Number} */
DR.web.GetInstagramFeed.prototype.count = null;
/** @type {Number} */
DR.web.GetInstagramFeed.prototype.pg = null;
/** @type {DR.web.struct.GetInstagramFeedRe} */
DR.web.GetInstagramFeed.prototype.re = null;
 
/** @extends {DR._Method} */
DR.web.GetQuotes = function(par){
	this.select = [];
	/** @private */
	this._t = 1376;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1376] = DR.web.GetQuotes;
DR.web.GetQuotes[__CL] = "Web__GetQuotes";
DR.web.GetQuotes.TYPE_GENERAL = "general";
DR.web.GetQuotes.TYPE_ONLINE = "online";
DR.web.GetQuotes.TYPE_EVENT = "event";
DR.web.GetQuotes.TYPE_CORPORATE = "corporate";
DR.web.GetQuotes.TYPE_LOCAL = "local";
DR.web.GetQuotes.TYPE_BUSINESS = "business";
DR.web.GetQuotes[__P] = new DR._Method;
DR.web.GetQuotes[__P][__C] = DR.web.GetQuotes;
/** @type {Number} */
DR.web.GetQuotes.prototype.count = null;
/** @type {Number} */
DR.web.GetQuotes.prototype.pg = null;
/** @type {String|null} */
DR.web.GetQuotes.prototype.type = null;
/** @type {DR.web.struct.GetQuotesRe} */
DR.web.GetQuotes.prototype.re = null;
 
/** @extends {DR._Method} */
DR.web.GetTrustedBy = function(par){
	this.select = [];
	/** @private */
	this._t = 1378;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1378] = DR.web.GetTrustedBy;
DR.web.GetTrustedBy[__CL] = "Web__GetTrustedBy";
DR.web.GetTrustedBy[__P] = new DR._Method;
DR.web.GetTrustedBy[__P][__C] = DR.web.GetTrustedBy;
/** @type {DR.web.struct.GetTrustedByRe} */
DR.web.GetTrustedBy.prototype.re = null;
 
/** @extends {DR._Method} */
DR.web.Stats = function(par){
	this.select = [];
	/** @private */
	this._t = 1326;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1326] = DR.web.Stats;
DR.web.Stats[__CL] = "Web__Stats";
DR.web.Stats[__P] = new DR._Method;
DR.web.Stats[__P][__C] = DR.web.Stats;
/** @type {DR.web.struct.StatsRe} */
DR.web.Stats.prototype.re = null;
 
D.loaded();